import * as api from "@nens/threedi/openapi-client";

import { RainRasters } from "../types/rasterRain";

export const RAIN_RASTERS: RainRasters = {
  nrr: {
    key: "nrr",
    type: "radar",
    uuid: "d6c2347d-7bd1-4d9d-a1f6-b342c865516f", // NRR 5min 3Di (m/s) raster
    unit: api.RasterRainUnitsEnum.M_S, // m/s
    displayValue: "Netherlands",
    description: "",
    isPublic: false,
    rasterStart: { kind: "RasterTimeRelative", relativeHours: -87600 }, // 24 * 365 * 10 = 10year
    rasterEnd: { kind: "RasterTimeRelative", relativeHours: 1 },
    frequency: "5min",
  },
  danishRadar: {
    key: "danishRadar",
    type: "radar",
    uuid: "8923cc8a-3ff9-400d-a448-756ed1bdf982",
    unit: api.RasterRainUnitsEnum.MM,
    displayValue: "Denmark",
    description:
      "This is a sample of the radar data provided by the Danish Meteorological Institute. Currently available between 11-1-2021 to 5-1-2022",
    isPublic: true,
    rasterStart: { kind: "RasterTimeAbsolute", dateTime: "2021-11-01T00:10:00Z" }, // 24 * 365 * 10 = 10year
    rasterEnd: { kind: "RasterTimeAbsolute", dateTime: "2022-05-01T00:00:00Z" },

    frequency: "10min",
  },
  iconGlobalHourly: {
    key: "iconGlobalHourly",
    type: "forecast",
    uuid: "36a184ee-8494-4374-886d-043466f9b132",
    unit: api.RasterRainUnitsEnum.MM_H, // mm/h
    displayValue: "ICON Global",
    description: (
      <p>
        Icon forecast, provided by the Deutscher Wetterdienst gives you a forecast of rainfall for
        the next 7 days, timestep 1 hour, unit mm, spatial resolution approximately 13x13 km. More
        information can be found{" "}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.dwd.de/EN/research/weatherforecasting/num_modelling/01_num_weather_prediction_modells/icon_description.html"
        >
          here
        </a>
      </p>
    ),
    isPublic: true,
    rasterStart: { kind: "RasterTimeRelative", relativeHours: -1 },
    rasterEnd: { kind: "RasterTimeRelative", relativeHours: 168 },

    frequency: "H",
  },
  iconEUHourly: {
    key: "iconEUHourly",
    type: "forecast",
    uuid: "b7aafee8-9396-42b4-ab20-87880228c8ec",
    unit: api.RasterRainUnitsEnum.MM_H, // mm/h
    displayValue: "ICON EU",
    description: (
      <p>
        Icon forecast, provided by the Deutscher Wetterdienst gives you a forecast of rainfall for
        the next 5 days, timestep 1 hour, unit mm, spatial resolution approximately 7x7 km. More
        information can be found{" "}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.dwd.de/EN/research/weatherforecasting/num_modelling/01_num_weather_prediction_modells/icon_description.html"
        >
          here
        </a>
      </p>
    ),
    isPublic: true,
    rasterStart: { kind: "RasterTimeRelative", relativeHours: -1 },
    rasterEnd: { kind: "RasterTimeRelative", relativeHours: 120 },

    frequency: "H",
  },
  iconGermanyHourly: {
    key: "iconGermanyHourly",
    type: "forecast",
    uuid: "4ba08b24-88a0-4ca5-bdac-d59b8d03e7c8",
    unit: api.RasterRainUnitsEnum.MM_H, // mm/h
    displayValue: "ICON-D2",
    description: (
      <p>
        Icon forecast, provided by the Deutscher Wetterdienst gives you a forecast of rainfall for
        the next 2 days, timestep 1 hour, unit mm, spatial resolution approximately 2.2x2.2 km. More
        information can be found{" "}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.dwd.de/EN/research/weatherforecasting/num_modelling/01_num_weather_prediction_modells/icon_description.html"
        >
          here
        </a>
      </p>
    ),
    isPublic: true,
    rasterStart: { kind: "RasterTimeRelative", relativeHours: -1 },
    rasterEnd: { kind: "RasterTimeRelative", relativeHours: 48 },

    frequency: "H",
  },
  qpeForecast: {
    key: "qpeForecast",
    type: "forecast",
    uuid: "d7952f9-63d7-42c8-b3f4-caf3d98ae473", // NRR 5min 3Di (m/s) raster
    unit: api.RasterRainUnitsEnum.M_S, // m/s
    displayValue: "QPE Forecast",
    description:
      "The QPE Forecast forecasts 6 hours in the future and has also 1 hour of observed data",
    isPublic: false,
    rasterStart: { kind: "RasterTimeRelative", relativeHours: -1 },
    rasterEnd: { kind: "RasterTimeRelative", relativeHours: 6 },
    frequency: "H", // todo find right interval
  },
};

export const getRainRasterByUuid = (rainRasters: RainRasters, uuid: string) => {
  const foundRainRasterTuple = Object.entries(rainRasters).find(
    ([key, value]) => value.uuid === uuid
  );
  if (foundRainRasterTuple) {
    return foundRainRasterTuple[1];
  } else {
    return null;
  }
};
